import {ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild} from "@angular/core";
import {AbstractListView} from "../../../core/visbos-core/ui/components/abstract-list-view";
import {SupplierService} from "../../services/supplier/supplier.service";
import {Supplier} from "../../../shared/view-model/crm/supplier.type";
import {SessionActions} from "../../../shared/actions/session.actions";
import {MessageType} from "../../../shared/redux-store/session/session.types";
import {ErrorHandlerService} from "../../../core/visbos-core/error-handling/error-handler.service";
import {SupplierFormComponent} from "../supplier-form/supplier-form.component";
import {GenericModalComponent} from "../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {ApolloQueryObservable} from "apollo-angular";
import {SupplierBusinessRelationsFormComponent} from "../../business-relations/supplier-business-relations-form/supplier-business-relations-form.component";

@Component({
  selector: 'vb-suppliers-list',
  templateUrl: './suppliers-list.component.html',
  styleUrls: ['./suppliers-list.component.css']
})
export class SuppliersListComponent extends AbstractListView implements OnInit {

  currentSupplier: Supplier;

  onCellUpdate(row, res, index) {
  }

  @ViewChild('addressTemplate')
  addressTemplate: TemplateRef<any>;

  @ViewChild('supplierForm')
  supplierForm: SupplierFormComponent;

  @ViewChild('businessRelationsForm')
  businessRelationsForm: SupplierBusinessRelationsFormComponent;

  @ViewChild('modal')
  supplierModal: GenericModalComponent;

  @ViewChild('businessRelationsModal')
  businessRelationsModal: GenericModalComponent;

  private suppliers$: ApolloQueryObservable<Supplier[]>;

  messages = {
    emptyMessage: 'Keine Lieferanten vorhanden',
    totalMessage: 'Lieferanten insgesamt'
  };


  constructor(private supplierService: SupplierService,
              private err: ErrorHandlerService,
              sessionActions: SessionActions, cd: ChangeDetectorRef) {
    super(sessionActions, cd);

    this.actions = [
      {
        label: 'Lieferanten hinzufügen',
        helpText: 'Einen neuen Lieferanten hinzufügen',
        icon: 'fa-plus',
        action: () => this.addSupplierClicked.apply(this),
      }
    ]

  }

  ngOnInit() {
    this.suppliers$ = this.supplierService.getSupplierList();
    this.addComponentData(this.suppliers$);

    this.dataSubscriptions.push(this.suppliers$.subscribe((res: any) => this.rows = res));

    this.columns = [
      {prop: 'name', name: 'Name'},
      {prop: 'administration_unit.label', name: 'Verwaltungseinheit'},
      {prop: 'address', name: 'Anschrift', cellTemplate: this.addressTemplate, sortable: false}
    ];
  }

  createOrUpdateSupplier() {
    this.supplierForm.createOrUpdateSupplier();
  }

  addSupplierClicked() {
    this.currentSupplier = undefined;
    this.cd.detectChanges();
    this.supplierForm.reset();
    this.supplierModal.show();
    this.cd.detectChanges();
  }

  editSupplierClicked(supplier: Supplier) {
    this.currentSupplier = supplier;
    this.cd.detectChanges();
    this.supplierForm.reset();
    this.supplierForm.control.enable();
    this.supplierModal.show();
    this.cd.detectChanges();
  }

  deleteSupplier(supplier: Supplier) {
    this.supplierService.deleteSupplier(supplier.cuid)
      .toPromise()
      .then((success: any) => {
        console.info("Success");
      });
  }

  editBusinessRelationClicked(supplier: Supplier) {
    this.currentSupplier = supplier;
    this.cd.detectChanges();
    this.businessRelationsForm.reset();
    this.businessRelationsModal.show();
    this.cd.detectChanges();
  }

  onAddCustomerDataClicked(supplier: Supplier) {
    this.currentSupplier = supplier;

    this.supplierForm.control.disable();
    this.supplierForm.control.get('business_relations').enable();

    this.supplierModal.show();
    this.cd.detectChanges();
  }

  createOrUpdateBusinessRelation() {
    let data = this.businessRelationsForm.control.value;

    this.supplierService.setSupplierBusinessRelations(
      data.relation.relation_target_id,
      data.relation.relation_source_id,
      data.relation_data,
      data.relation.cuid
    ).subscribe(res => {
        this.sessionActions.pushMessage("Geschäftsbeziehung erfolgreich gespeichert!", MessageType.SUCCESS, "Lieferantenverwaltung");
      },
      err => {
        this.sessionActions.throwError(err, "Fehler beim Speichern der Geschäftsbeziehung!");
      }
    );


  }

}



// WEBPACK FOOTER //
// ./src/app/crm/supplier/suppliers-list/suppliers-list.component.ts